// ============================================================================
// API Config - PUENTE que referencia .env
// Configuración centralizada que lee desde variables de ambiente
// Archivos de origen: .env (desarrollo), .env.qa (QA), .env.pro (PRODUCCIÓN)
// ============================================================================

const normalizarTimeoutApi = (valor: string | undefined, porDefecto: number): number => {
  const numero = Number(valor);
  if (!Number.isFinite(numero) || numero <= 0) {
    return porDefecto;
  }
  return numero;
};

// Determinar ENTORNO desde variable Vite
const entorno = import.meta.env.VITE_ENTORNO as 'PRUEBA' | 'PRODUCCION';
export const ENTORNO: 'PRUEBA' | 'PRODUCCION' = entorno || 'PRUEBA';

export const API_CONFIG = {
  BASE_URL: (import.meta.env.VITE_API_URL as string) || 'http://localhost:5242',
  API_VERSION: (import.meta.env.VITE_API_VERSION as string) || 'v1',
  TIMEOUT: normalizarTimeoutApi(import.meta.env.VITE_API_TIMEOUT as string | undefined, 30000),
  API_FACTURACION: (import.meta.env.VITE_API_FACTURACION as string) || 'https://api-facturacion.smartbusinessdev.com/api/v2',
  COMPROBANTE_CONSULTA_URL: (import.meta.env.VITE_COMPROBANTE_CONSULTA_URL as string) || 'https://cdpev2.smartbusinessdev.com',
  // Sin fallback: una key vacia desactiva Amplitude en todos los entornos.
  KEI_AMPLITUDE: (import.meta.env.VITE_KEI_AMPLITUDE as string) || '',
  INFO_CONTASIS_URL: (import.meta.env.VITE_INFO_CONTASIS_URL as string) || 'https://info.contasis.com',
} as const;

export const CHECK_MAIL_CONFIG = {
  API_KEY: import.meta.env.VITE_CHECK_MAIL_API_KEY as string,
  API_URL: '/checkmail-proxy',
} as const;

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_SERVER_ERROR: 500,
} as const;

export const STORAGE_KEYS = {
  TOKEN: 'senciyo_token',
  REFRESH_TOKEN: 'senciyo_refresh_token',
  USER: 'senciyo_user',
  EXPIRES_AT: 'senciyo_expires_at',
  EMPRESA_ID: 'senciyo_empresa_id',
  ESTABLECIMIENTO_ID: 'senciyo_establecimiento_id',
  TOKEN_API_FACTURACION: 'senciyo_token_api_facturacion',
  AUTH_STORE: 'senciyo-auth-store',
} as const;
